import { DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI } from '../../../types/default-cloud-graph-customer-org-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI } from '../../../types/default-cloud-graph-deal-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo, RovoLogoFromGlyph } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { HubSpotFilterIcon, HubSpotIcon } from './icon';

export const hubSpotConfig: ThirdPartyConfig = {
	displayName: 'HubSpot',
	id: 'hubspot',
	resourceType: ProductResourceTypes3P.Hubspot,
	icon: get3PLogo(HubSpotFilterIcon, 'HubSpot', 'medium'),
	searchResultIcon: RovoLogoFromGlyph(HubSpotIcon, 'HubSpot'),
	integrationAri: 'ari:cloud:platform::integration/hubspot',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.CustomerOrg,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Deal,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Deal],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch', 'lastUpdatedBy', 'createdBy'],
	requiresOauth: true,
	isEnabled: () => true,
};
